













import { Component, Vue } from 'vue-property-decorator';
import User from '@/components/searchResults/user/User.vue';
import { store } from '@/utils/store';

@Component({
  components: {
    User,
  },
})
export default class SearchResults extends Vue {
  get searchResults() {
    if (store.searchResults) {
      const resultList = Object.entries(store.searchResults).map(([name, result]) => {
        const temp = {
          name,
          result,
        };
        return temp;
      });
      return resultList;
    }
    return null;
  }
}
